import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class GtmAnalyticsService {
  private loaded = false;
 private gtmContainerId = JSON.stringify(environment.gtmContainerId);
  loadAnalytics(): void {
    if (this.loaded) return;

    const script = document.createElement("script");
    script.text = `
      (function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({
      "gtm.start": new Date().getTime(),
      event: "gtm.js",
    });
    var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l != "dataLayer" ? "&l=" + l : "";
    j.async = true;
    j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, "script", "dataLayer", ${this.gtmContainerId});
  `;
    document.head.appendChild(script);

    const noscript = document.createElement("noscript");
    noscript.innerHTML = `
      <iframe src="https://www.googletagmanager.com/ns.html?id=${this.gtmContainerId}" height="0" width="0"
            style="display:none;visibility:hidden"></iframe>
    `;
    document.body.appendChild(noscript);

    this.loaded = true;
  }
}
